import { useSelector } from "react-redux";

export default function PreviewPage() {
  const companyName = useSelector((state) => state.Company.company_name);
  const showSection = useSelector((state) => state.EMenu.showSection);

  return (
    <div
      className={`${
        showSection ? "block" : "max-md:hidden"
      } m-auto h-full flex items-center`}
    >
      <div className="w-[90%] text-center m-auto px-24">
        <p className="uppercase font-extrabold tracking-tight text-3xl leading-[1%]">
          {companyName}
          <span className="text-secondary font-black text-6xl">.</span>
        </p>
        <div className="flex w-[60%] m-auto items-center text-center">
          <div className="border-t border-secondary w-[50%]"></div>
          <div className="w-[50%] ">
            <p className="capitalize text-secondary ">
              E-Menu by <span className="font-black">CRANESOFT</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
